import { useEffect, useState } from 'react'

import { loadFlags } from '@/services/feature-flag'
import { loadAppSessionId, setLocale, setStack } from '@/stores/config'

import { AppProps } from '@/types/app-props'
import { getCommonsNorthboundAPIs } from '@foreign-clientos/dependency-manager'

export function useInitApp(props: AppProps) {
  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    setStack(props.stack)
    setLocale(getCommonsNorthboundAPIs().v1.localization)
    Promise.all([
      /**
       * All promises needed to be resolved before the initialization of the app should be added here
       */
      loadFlags(),
      loadAppSessionId(),
    ]).then(() => setInitialized(true))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return initialized
}
